































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ModalTemplate2 extends Vue {
    @Prop() data!: any;

    @Prop({ required: true }) modalId!: string;

    @Prop({ required: false, default: false }) showOnPageLoad!: boolean;
    @Prop({ required: false, default: () => [] }) includePages!: any;
    @Prop({ required: false, default: () => [] }) excludePages!: any;

    open = false;

    mounted() {
        if (this.getCookie(`liberoo-session-${this.modalId}`)) {
            return;
        }

        if (this.showOnPageLoad && this.includePages.length === 0 && this.excludePages.length === 0) {
            this.open = true;
        }

        if (this.showOnPageLoad && this.includePages.length > 0 && this.excludePages.length === 0) {
            this.open = this.includePages.includes(window.location.href);
        }

        if (this.showOnPageLoad && this.includePages.length === 0 && this.excludePages.length > 0) {
            this.open = !this.excludePages.includes(window.location.href);
        }

        if (this.showOnPageLoad && this.includePages.length > 0 && this.excludePages.length > 0) {
            this.open = this.includePages.includes(window.location.href) && !this.excludePages.includes(window.location.href);
        }
    }

    closeModal() {
        this.open = false;

        if (this.showOnPageLoad) {
            this.setCookie(`liberoo-session-${this.modalId}`, "true");
        }
    }

    setCookie = (name: string, value: string, days?: number) => {
        if (days) {
            var expires = "";
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
            document.cookie = name + "=" + value + expires + "; path=/";
        } else {
            document.cookie = name + "=" + value + "; path=/";
        }
    };

    getCookie = (name: string) => {
        var nameEQ = name + "=";
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            while (cookie.charAt(0) === " ") cookie = cookie.substring(1, cookie.length);
            if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length, cookie.length);
        }
        return null;
    };
}
